import React from "react";

import { InformationBox } from "../InformationBox/InformationBox";
import { UserViewType } from "../UserViewType/UserViewType";

import "./StructureHeader.scss";

interface Props {
  title: string;
  hideBorder?: boolean;
  message?: string | undefined;
  showUserViewType?: boolean;
  userViewType?: string;
}

export const StructureHeader = ({
  title,
  hideBorder,
  message,
  showUserViewType,
  userViewType,
}: Props) => {
  return (
    <div className="StructureHeader">
      <div className="StructureHeader__title">
        <h1>{title}</h1>
        {message && <InformationBox message={message} />}
        {showUserViewType && <UserViewType type={userViewType} />}
      </div>
    </div>
  );
};
